import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";
import { useAnyHoverMediaQuery } from "@/react/hooks/useMediaQuery";

interface DeleteImageButtonProps {
  currentImageIndex: number;
  index: number;
  onClick: () => void;
}
export const DeleteImageButton = ({
  onClick,
  index,
  currentImageIndex,
}: DeleteImageButtonProps) => {
  const canHover = useAnyHoverMediaQuery();
  return (
    <button
      aria-label={t("delete_image")}
      onClick={onClick}
      type="button"
      className={classNames(
        "bg-tertiary border-secondary outline-tertiary absolute -right-0.5 -top-0.5 z-10 hidden size-4 items-center justify-center rounded-full border outline outline-2",
        { "group-hover:flex": true },
        { flex: !canHover && index === currentImageIndex },
      )}
    >
      <Icon name="cross" size="sm" width={10} height={10} />
    </button>
  );
};
